<div class="payment-confirmer-container">
  <div class="payment-confirmer-card-box-wrapper">
    <div class="payment-confirmer-info-box">
      <h3 class="payment-confirmer-greeting" id="card"><span [translate]="'GREETING'" [translateParams]="{value: user && user.name ? user.name : ''}"></span></h3>
      <p class="payment-confirmer-message"
         *ngIf="!paymentFailed() && !paymentSuccess() && paymentParams" translate>SUBSCRIPTION_PAYMENT_CONTENT</p>
      <p class="payment-confirmer-message"
         *ngIf="paymentFailed() && paymentParams">
        <span [innerHtml]="'SUBSCRIPTION_PAYMENT_FAILED_CONTENT' | translate"></span>
        <a href="#" (click)="contactSupport()" class="support-link">{{'CONTACT_SUPPORT' | translate}}</a>
      </p>
      <br>
      <p class="payment-confirmer-message"
         *ngIf="!paymentFailed() && !paymentSuccess() && paymentParams" translate>SUBSCRIPTION_CLICK</p>
      <p class="payment-confirmer-message"
         *ngIf="paymentSuccess()" translate>SUBSCRIPTION_PAYMENT_SUCCESS</p>
    </div>
    <div class="icon-success" *ngIf="paymentSuccess()">
      <img src="assets/img/payment_success_icon.svg" alt="success">
    </div>
    <div class="icon-success" *ngIf="paymentFailed()">
      <img src="assets/img/payment_failed_icon.svg" alt="success">
    </div>
    <div class="payment-box"
         [class.bordered]="!paymentFailed() && paymentParams">
      <h4 class="payment-box-title" translate>PAYMENT <span *ngIf="paymentSuccess()">
        {{'SUCCEEDED' | translate}}!
      </span>
      <span *ngIf="paymentFailed()">
        {{'PAYMENT_FAILED' | translate}}!
      </span>
      </h4>
      <div class="payment-box-item" *ngIf="!paymentSuccess() && paymentParams">
        <div class="item-block">
          <span class="item-label" translate>PLANS.CARD_TITLE</span>
          <div class="item-value">
            <p class=""><span *ngIf="activeCard && activeCard.brand">{{activeCard.brand}}</span></p>
          </div>
        </div>
        <div class="item-block">
          <span class="item-label" translate>PLANS.NUMBER</span>
          <div class="item-value">
            <span translate>PLANS.NUMBER_STAR</span>
            <span *ngIf="activeCard && activeCard.last4Digits">{{activeCard.last4Digits}}</span>
          </div>
        </div>
        <div class="item-block">
          <span class="item-label" translate>PLANS.EXPIRY_DATE</span>
          <div class="item-value" *ngIf="activeCard && activeCard.expMonth && activeCard.expYear">
            <span>{{activeCard.expMonth}}</span> / <span>{{activeCard.expYear}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="payment-box info-confirm"
         [class.bordered]="(paymentFailed() || !paymentSuccess()) && paymentParams"
         *ngIf="!paymentFailed() && paymentParams">
      <div class="payment-box-item">
        <span class="info-value">{{'TOTAL' | translate}}:</span>
      </div>

      <div class="payment-box-item" *ngIf="!subscriptionParams">
        <span class="item-label" translate>SETTINGS.AUTO_RECHARGE.CALLS_CHARGE</span>
      </div>

      <div class="payment-box-item" *ngIf="subscriptionParams && subscriptionParams.plan && subscriptionParams.quantity">
        <span class="item-label">{{subscriptionParams.plan}}</span>
        <span class="info-value"> x{{ subscriptionParams.quantity }}</span>
      </div>

      <div class="card-box-item" *ngIf="paymentParams.amount">
        <span class="item-label" translate>SETTINGS.AUTO_RECHARGE.AMOUNT</span>
        <span class="info-value">
          {{paymentParams.amount | currency: paymentParams.currency === 'usd' ? '$' : paymentParams.currency}}
        </span>
      </div>
    </div>
    <div class="subscribe-payment-button-wrapper" *ngIf="!paymentFailed() && !paymentSuccess() && paymentParams">
      <button type="submit" class="btn subscribe-payment-button"
              (click)="confirm(true)"
              translate>
        <span *ngIf="!subscriptionParams" translate>COMPLETE_PAYMENT</span>
        <span *ngIf="subscriptionParams" translate>PAY</span>
        <span *ngIf="subscriptionParams && paymentParams && paymentParams.amount"> {{paymentParams.amount | currency: paymentParams.currency === 'usd' ? '$' : paymentParams.currency }}</span>
      </button>
    </div>
  </div>
</div>
